module.exports = __webpack_public_path__ + "img/Copy_icon.ca97cccd.svg";